import { Col, Row, Table } from 'antd';
import { priceToString } from '../../util/utils';
import { ProjectRevenue } from '../../modules/projects';
import { ColumnsType } from 'antd/lib/table';
import Title from 'antd/lib/typography/Title';

interface RevenueContractListComponentProps {
  projectRevenue: ProjectRevenue;
}

function RevenueContractListComponent({
  projectRevenue,
}: RevenueContractListComponentProps) {
  const columns: ColumnsType<any> = [
    {
      title: '날짜',
      width: '13%',
      render: (text: any, record: any) => {
        return record.changeDate ? record.changeDate : record.contractDate;
      },
    },
    {
      title: '종류',
      width: '9%',
      render: (text: any, record: any) => {
        return record.changeDate ? '설계변경' : '도급계약';
      },
    },
    {
      title: '제목',
      dataIndex: 'title',
      width: '40%',
      ellipsis: true,
      render: (text: any, record: any) => <>{text}</>,
    },
    // {
    //   title: '상태',
    //   dataIndex: 'status',
    //   render: (text: any, record: ChangeOrder) =>
    //     changeOrderStatusKorean[record.status],
    // },

    {
      title: '공급가액(원)',
      dataIndex: ['priceData', 'priceData', 'supplyPrice'],
      width: '13%',
      align: 'right',
      render: (text: any, record: any) => priceToString(text),
    },
    {
      title: '부가세액(원)',
      dataIndex: ['priceData', 'priceData', 'vat'],
      width: '13%',
      align: 'right',
      render: (text: any, record: any) => priceToString(text),
    },
    {
      title: '합계금액(원)',
      dataIndex: ['priceData', 'priceData', 'totalPrice'],
      width: '14%',
      align: 'right',
      render: (text: any, record: any) => priceToString(text),
    },
  ];

  return (
    <>
      <Row style={{ marginTop: '30px' }}>
        <Col>
          <Title level={5}>계약정보</Title>
        </Col>
      </Row>
      <Row>
        <Col span={24}>
          <Table<any>
            rowKey="id"
            columns={columns}
            dataSource={[
              ...projectRevenue.contracts,
              ...projectRevenue.changeOrders,
            ]}
            pagination={{
              defaultPageSize: 10,
              showSizeChanger: true,
              pageSizeOptions: ['10', '20'],
              position: ['bottomCenter'],
            }}
            summary={(pageData) => {
              let totalValue1 = 0;
              let totalValue2 = 0;
              let totalValue3 = 0;

              pageData.forEach(({ priceData }) => {
                totalValue1 += priceData.priceData.supplyPrice;
                totalValue2 += priceData.priceData.vat;
                totalValue3 += priceData.priceData.totalPrice;
              });

              return (
                <>
                  {
                    <Table.Summary.Row>
                      <Table.Summary.Cell index={0}></Table.Summary.Cell>
                      <Table.Summary.Cell index={1}></Table.Summary.Cell>
                      <Table.Summary.Cell index={2} align="right">
                        Total:
                      </Table.Summary.Cell>
                      <Table.Summary.Cell index={3} align="right">
                        {priceToString(totalValue1)}
                      </Table.Summary.Cell>
                      <Table.Summary.Cell index={4} align="right">
                        {priceToString(totalValue2)}
                      </Table.Summary.Cell>
                      <Table.Summary.Cell index={5} align="right">
                        {priceToString(totalValue3)}
                      </Table.Summary.Cell>
                      <Table.Summary.Cell index={6}></Table.Summary.Cell>
                    </Table.Summary.Row>
                  }
                </>
              );
            }}
          />
        </Col>
      </Row>
    </>
  );
}

export default RevenueContractListComponent;
